export function selectRandomVariant<T extends Record<string, string>>(
  enumObj: T,
): T[keyof T] {
  const variants = Object.values(enumObj) as T[keyof T][];
  return variants[Math.floor(Math.random() * variants.length)];
}
